import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { ARTICLES } from "@/lib/blog";
import { Reveal } from "@/components/motion-primitives";
import { SectionHead, CtaBand, usePageMeta } from "@/components/shared";
import Newsletter from "@/components/Newsletter";

export default function Blog() {
  usePageMeta("Resource Center", "The Bermuda Vacation Rental Resource Center — guides on co-hosting, cleaning, overseas ownership and starting a vacation rental in Bermuda.");
  const [featured, ...rest] = ARTICLES;
  return (
    <main>
      <section className="mx-auto max-w-[1440px] px-6 pb-24 pt-40 lg:px-10">
        <SectionHead
          overline="Bermuda Vacation Rental Resource Center"
          title={<>Knowledge for owners<br /><span className="italic text-bermuda-dark">who care about doing it right.</span></>}
          copy="Practical, island-specific guidance on starting, operating and protecting a Bermuda vacation rental."
        />

        <Reveal delay={0.15}>
          <Link to={`/resources/${featured.slug}`} data-testid="blog-featured-article" className="group mt-16 grid overflow-hidden border border-navy/10 bg-white lg:grid-cols-2">
            <div className="img-frame h-72 lg:h-auto">
              <img src={featured.image} alt={featured.title} className="h-full w-full object-cover" />
            </div>
            <div className="flex flex-col justify-center p-10 lg:p-14">
              <p className="text-[10px] font-semibold uppercase tracking-[0.25em] text-bermuda-dark">Featured Guide · {featured.readTime}</p>
              <h2 className="mt-4 font-serif text-3xl leading-tight text-navy lg:text-4xl">{featured.title}</h2>
              <p className="mt-4 text-sm leading-relaxed text-navy/60">{featured.excerpt}</p>
              <span className="mt-6 flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-navy group-hover:text-bermuda-dark transition-colors">
                Read the Guide <ArrowUpRight size={14} />
              </span>
            </div>
          </Link>
        </Reveal>

        <div className="mt-12 grid gap-8 md:grid-cols-3">
          {rest.map((a, i) => (
            <Reveal key={a.slug} delay={i * 0.08}>
              <Link to={`/resources/${a.slug}`} data-testid={`blog-card-${a.slug}`} className="group block h-full border border-navy/10 bg-white transition-all duration-500 hover:border-bermuda hover:shadow-xl hover:shadow-navy/5">
                <div className="img-frame h-52">
                  <img src={a.image} alt={a.title} className="h-full w-full object-cover" loading="lazy" />
                </div>
                <div className="p-7">
                  <p className="text-[10px] uppercase tracking-[0.2em] text-navy/45">{a.date} · {a.readTime}</p>
                  <h3 className="mt-3 font-serif text-xl leading-snug text-navy">{a.title}</h3>
                  <p className="mt-3 text-[13px] leading-relaxed text-navy/55">{a.excerpt}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>

      </section>
      <Newsletter />
      <CtaBand title="Prefer answers specific to your property?" copy="Guides are general. Your assessment is personal — request one and we'll talk about your home, not a hypothetical." />
    </main>
  );
}
